import OfferRate from './OfferRate';

export default OfferRate;
